import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=27120202&scoped=true&"
import script from "./ListTable.vue?vue&type=script&lang=js&"
export * from "./ListTable.vue?vue&type=script&lang=js&"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=27120202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27120202",
  null
  
)

export default component.exports